/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */

import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Card,
  CardContent,
  // CardActions,
  CardHeader,
  // InputAdornment,
  // IconButton,
  // MenuItem,
  Button,
  CircularProgress,
  Grid,
  TextField
} from '@mui/material';
// import { ExpandMore } from '@mui/icons-material';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import SettingAction from '../../../store/actions/SettingAction';
import ContentLoader from '../../../utils/errorPages/ContentLoader';
import { ValidatePayPal } from '../../../assets/validation';
import useHasPermission from '../../../utils/useHasPermission';
import { paymentSettings, index, store } from '../../../utils/constants';
import IOSSwitchStyle from '../../../components/SwitchField';

export default function PaymentPaypal() {
  const [data, setData] = useState([]);
  const [modeValue, setModeValue] = useState('');

  const dispatch = useDispatch();
  const { paypalData, isLoading } = useSelector((state) => state.setting); // Replace 'data' with your reducer name

  useEffect(() => {
    dispatch(SettingAction.getPaypal());
  }, [dispatch]);

  useEffect(() => {
    if (paypalData && paypalData?.data) {
      setData(paypalData.data);
      if (paypalData.data?.PAYPAL_MODE) {
        setModeValue(paypalData.data.PAYPAL_MODE);
      }
    }
  }, [paypalData]);

  const getDirtyValues = (values, initialObject) => {
    const newdata = { ...values };
    const keyValues = Object.keys(newdata);

    const dirtyValues = keyValues.filter(
      (keyValue) => newdata[keyValue] !== initialObject[keyValue]
    );

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete newdata[key];
    });
    return newdata;
  };

  const initialValues = {
    PAYPAL_MODE: data?.PAYPAL_MODE ?? '',
    PAYPAL_SANDBOX_CLIENT_ID: data?.PAYPAL_SANDBOX_CLIENT_ID ?? '',
    PAYPAL_SANDBOX_CLIENT_SECRET: data?.PAYPAL_SANDBOX_CLIENT_SECRET ?? '',
    PAYPAL_SANDBOX_WEBHOOK_ID: data?.PAYPAL_SANDBOX_WEBHOOK_ID ?? '',
    PAYPAL_LIVE_CLIENT_ID: data?.PAYPAL_LIVE_CLIENT_ID ?? '',
    PAYPAL_LIVE_CLIENT_SECRET: data?.PAYPAL_LIVE_CLIENT_SECRET ?? '',
    PAYPAL_LIVE_WEBHOOK_ID: data?.PAYPAL_LIVE_WEBHOOK_ID ?? '',
    PAYPAL_IS_ENABLED: data?.PAYPAL_IS_ENABLED
  };

  const permissionAccess = !(
    useHasPermission(paymentSettings, index) && useHasPermission(paymentSettings, store)
  );

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      {isLoading ? <ContentLoader /> : ''}
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={ValidatePayPal}
        onSubmit={(values, { setErrors, setSubmitting }) => {
          console.log(values, 'values');
          const updateValues = getDirtyValues(values, initialValues);
          dispatch(SettingAction.updatePaypal(updateValues, setErrors, setSubmitting));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                  <Grid item lg={3} xl={2}>
                    <FormControl sx={{ mt: 2, width: '100%', textAlign: 'left' }}>
                      <FormLabel id="statusId" required={!permissionAccess}>
                        PayPal Mode
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="statusId-label"
                        name="PAYPAL_MODE"
                        value={values.PAYPAL_MODE}
                        onChange={(e) => {
                          setFieldValue('PAYPAL_MODE', e.target.value);
                          setModeValue(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          // disabled={permissionAccess}
                          value="sandbox"
                          control={<Radio />}
                          label="Sandbox"
                        />
                        <FormControlLabel
                          // disabled={permissionAccess}
                          value="live"
                          control={<Radio />}
                          label="Live"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item lg={3} xl={3}>
                    <FormControl sx={{ mt: 2, width: '100%', textAlign: 'left' }}>
                      <FormLabel id="statusId" required={!permissionAccess} sx={{ mb: 1 }}>
                        Status
                      </FormLabel>
                      <IOSSwitchStyle
                        size="small"
                        disabled={permissionAccess}
                        checked={values.PAYPAL_IS_ENABLED === 1}
                        value={values.PAYPAL_IS_ENABLED}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setFieldValue('PAYPAL_IS_ENABLED', 1);
                          } else {
                            setFieldValue('PAYPAL_IS_ENABLED', 2);
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                {modeValue === 'sandbox' ? (
                  <Card sx={{ mt: 2, maxWidth: '65%' }}>
                    <CardHeader
                      sx={{ textAlign: 'left !important' }}
                      title="Sandbox Configuration"
                    />
                    <CardContent>
                      <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={
                              errors.PAYPAL_SANDBOX_CLIENT_ID && touched.PAYPAL_SANDBOX_CLIENT_ID
                            }
                            label="Paypal Sandbox Client ID"
                            className=""
                            fullWidth
                            type="text"
                            name="PAYPAL_SANDBOX_CLIENT_ID"
                            value={values.PAYPAL_SANDBOX_CLIENT_ID}
                            // maxRows={4}
                            disabled={permissionAccess}
                            placeholder="Enter Client ID"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.PAYPAL_SANDBOX_CLIENT_ID &&
                              touched.PAYPAL_SANDBOX_CLIENT_ID &&
                              errors.PAYPAL_SANDBOX_CLIENT_ID
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={
                              errors.PAYPAL_SANDBOX_CLIENT_SECRET &&
                              touched.PAYPAL_SANDBOX_CLIENT_SECRET
                            }
                            label="Paypal Sandbox Client Secret"
                            className=""
                            fullWidth
                            disabled={permissionAccess}
                            type="text"
                            name="PAYPAL_SANDBOX_CLIENT_SECRET"
                            value={values.PAYPAL_SANDBOX_CLIENT_SECRET}
                            // maxRows={4}
                            placeholder="Enter Client Secret"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.PAYPAL_SANDBOX_CLIENT_SECRET &&
                              touched.PAYPAL_SANDBOX_CLIENT_SECRET &&
                              errors.PAYPAL_SANDBOX_CLIENT_SECRET
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={12} xl={12}>
                          <TextField
                            error={
                              errors.PAYPAL_SANDBOX_WEBHOOK_ID && touched.PAYPAL_SANDBOX_WEBHOOK_ID
                            }
                            label="Paypal Sandbox Webhook ID"
                            fullWidth
                            disabled={permissionAccess}
                            type="text"
                            name="PAYPAL_SANDBOX_WEBHOOK_ID"
                            value={values.PAYPAL_SANDBOX_WEBHOOK_ID}
                            placeholder="Enter Webhook ID (required for webhook verification)"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.PAYPAL_SANDBOX_WEBHOOK_ID &&
                              touched.PAYPAL_SANDBOX_WEBHOOK_ID &&
                              errors.PAYPAL_SANDBOX_WEBHOOK_ID
                            }
                            margin="normal"
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                ) : (
                  <Card sx={{ mt: 2, maxWidth: '65%' }}>
                    <CardHeader sx={{ textAlign: 'left !important' }} title="Live Configuration" />
                    <CardContent>
                      <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                        <Grid item lg={6} xl={6}>
                          <TextField
                            id="PAYPAL_LIVE_CLIENT_ID"
                            fullWidth
                            type="text"
                            label="Paypal Live Client ID"
                            name="PAYPAL_LIVE_CLIENT_ID"
                            margin="normal"
                            placeholder="Enter Client ID"
                            value={values.PAYPAL_LIVE_CLIENT_ID}
                            onChange={handleChange}
                            disabled={permissionAccess}
                            onBlur={(e) => {
                              const val = (e.target.value || '').replace(/\s+/gi, '');
                              setFieldValue(e.target.name, val.trim());
                              handleBlur(e);
                            }}
                            error={errors.PAYPAL_LIVE_CLIENT_ID && touched.PAYPAL_LIVE_CLIENT_ID}
                            helperText={
                              errors.PAYPAL_LIVE_CLIENT_ID &&
                              touched.PAYPAL_LIVE_CLIENT_ID &&
                              errors.PAYPAL_LIVE_CLIENT_ID
                            }
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                            // InputProps={{
                            //   endAdornment: (
                            //     <InputAdornment position="start">
                            //       <IconButton aria-label="toggle password visibility" edge="end" disabled>
                            //         <MailOutlineOutlinedIcon />
                            //       </IconButton>
                            //     </InputAdornment>
                            //   )
                            // }}
                          />
                        </Grid>
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={
                              errors.PAYPAL_LIVE_CLIENT_SECRET && touched.PAYPAL_LIVE_CLIENT_SECRET
                            }
                            label="Paypal Live Client Secret"
                            className=""
                            fullWidth
                            name="PAYPAL_LIVE_CLIENT_SECRET"
                            value={values.PAYPAL_LIVE_CLIENT_SECRET}
                            disabled={permissionAccess}
                            type="text"
                            // maxRows={4}
                            placeholder="Enter Client Secret"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.PAYPAL_LIVE_CLIENT_SECRET &&
                              touched.PAYPAL_LIVE_CLIENT_SECRET &&
                              errors.PAYPAL_LIVE_CLIENT_SECRET
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={12} xl={12}>
                          <TextField
                            error={errors.PAYPAL_LIVE_WEBHOOK_ID && touched.PAYPAL_LIVE_WEBHOOK_ID}
                            label="Paypal Live Webhook ID"
                            fullWidth
                            disabled={permissionAccess}
                            type="text"
                            name="PAYPAL_LIVE_WEBHOOK_ID"
                            value={values.PAYPAL_LIVE_WEBHOOK_ID}
                            placeholder="Enter Webhook ID (required for webhook verification)"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.PAYPAL_LIVE_WEBHOOK_ID &&
                              touched.PAYPAL_LIVE_WEBHOOK_ID &&
                              errors.PAYPAL_LIVE_WEBHOOK_ID
                            }
                            margin="normal"
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                )}
              </CardContent>
              {!permissionAccess ? (
                <CardContent
                  sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.06)',
                    p: 2,
                    columnGap: '16px',
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                      setModeValue(data?.PAYPAL_MODE);
                    }}
                  >
                    Clear
                  </Button>
                </CardContent>
              ) : (
                ''
              )}
            </Card>
          </form>
        )}
      </Formik>
    </Box>
  );
}
